/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Example_BodyInputs */

const da_forside_example_body = /** @type {(inputs: Forside_Example_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hent en fiktiv terminsprøve med rettevejledning, omsætningstabel og tre elevbesvarelser på forskellige niveauer. Alle navne er opdigtede, så du kan prøve hele forløbet – også at dække navne – uden at bruge rigtige elevdata.`)
};

/** @type {(inputs: Forside_Example_BodyInputs) => LocalizedString} */
const en_forside_example_body = da_forside_example_body;

/**

* @param {Forside_Example_BodyInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_example_body = /** @type {((inputs?: Forside_Example_BodyInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Example_BodyInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_example_body(inputs)
	return /** @type {LocalizedString} */ ("Hent en fiktiv terminsprøve med rettevejledning, omsætningstabel og tre elevbesvarelser på forskellige niveauer. Alle navne er opdigtede, så du kan prøve hele forløbet – også at dække navne – uden at bruge rigtige elevdata.")
});